module.exports = __webpack_public_path__ + "img/logo_1_banco-central.1c8dc3a0.jpg";